import getUAString from '../utils/userAgent.js';

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

export { isLayoutViewport as default };
//# sourceMappingURL=isLayoutViewport.js.map
